import { FlexBox } from "@brg/ui";
import styled from "styled-components";

export const BackButtonWrapper = styled(FlexBox)`
    
    .small-text {
        color: ${({ theme }) => theme.tags.textColor} !important;
        opacity: 0.47;
        transition: opacity 0.2s;
        cursor: pointer;

        &:hover {
            opacity: 1;
            transition: opacity 0.2s;
        }
    }

    svg {
        transform: rotate(90deg);
        cursor: pointer;
    }
`;import { FlexBox } from "@brg/ui";
import styled from "styled-components";

export const BackButtonWrapper = styled(FlexBox)`
    
    .small-text {
        color: ${({ theme }) => theme.tags.textColor} !important;
        opacity: 0.47;
        transition: opacity 0.2s;
        cursor: pointer;

        &:hover {
            opacity: 1;
            transition: opacity 0.2s;
        }
    }

    svg {
        transform: rotate(90deg);
        cursor: pointer;
    }
`;